import { render } from "./MetricDashboardSemesterGraphic.vue?vue&type=template&id=2f67c73c&ts=true"
import script from "./MetricDashboardSemesterGraphic.vue?vue&type=script&lang=ts"
export * from "./MetricDashboardSemesterGraphic.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__